import {Column, Entity, TableInheritance} from "typeorm";
import {BaseEntity} from "@/modules/base/entity/BaseEntity";
import {LocationAsRelativeRaw} from "vue-router";
import {Component} from "@vue/runtime-core";
import {ShallowRef} from "vue";

@Entity({orderBy: {id: 'ASC'}})
@TableInheritance({column: {type: "varchar", name: "type"}})
export class Notification extends BaseEntity {
  @Column({type: "date"})
  createdAt: Date;

  @Column({type: "boolean"})
  read = false;

  @Column({type: "varchar", nullable: true})
  payloadRaw?: string;

  get to(): LocationAsRelativeRaw | undefined {
    return undefined;
  }

  get component(): ShallowRef<Component> {
    throw 'No component defined';
  }
}
